/// <reference path="../../../../../../typings/index.d.ts" />
module Meevo.Plugins.RatingsControlPanel {

    import SecurityKeys = Meevo.Components.Common.SecurityKeys;

    export class MeevoRatingsControlPanelClientDetailsComponent implements angular.IComponentController {
        client: IRatingSelectedClient;

        static $inject = [
            '$scope',
            'meevo.AppSettings',
        ];

        get securityKeys() {
            return SecurityKeys;
        }

        constructor(
            private $scope: ng.IScope,
            private appSettings: Meevo.Components.Common.IAppSettings
            ){
        }

        public goToClient() {
            this.$scope.$emit(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    callback: null,
                    callbackState: null,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    id: this.client.clientInfo.id
                },
            })
        }
    }

    angular.module('meevo.plugins.ratingsControlPanel')
        .component('meevoRatingsControlPanelClientDetailsComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/ratingsControlPanel/components/clientDetails/client-details.template.html',
            controller: MeevoRatingsControlPanelClientDetailsComponent,
            controllerAs: '$ctrl',
            bindings: {
                client: '='
            }
        });
}